"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/Forms/TagField.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);


var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);

var _Popover = require('web/components/Popover'); var _Popover2 = _interopRequireDefault(_Popover);
var _format = require('web/screens/Directory/PatientTable/format');

// The org's tags a patient gets (TagKeys), and the names of tags created for
// them (NewNames), found or created by name on the server as tagging does.





 const EMPTY_TAG_FIELD = { TagKeys: [], NewNames: [] }; exports.EMPTY_TAG_FIELD = EMPTY_TAG_FIELD

 const isTagFieldEmpty = (value) => value.TagKeys.length === 0 && value.NewNames.length === 0; exports.isTagFieldEmpty = isTagFieldEmpty

const TAG_NAME_MAX = 64

const nameKey = (name) => name.trim().toLowerCase()




















const joinNames = (names) => names.length <= 1
  ? names.join('')
  : `${names.slice(0, -1).join(', ')} and ${names[names.length - 1]}`

/* A1 (D-96): the patient's tags as removable badges inside a text input.
 * Typing opens a menu of the org's matching tags with their patient counts
 * (most used first when nothing is typed) and "Create tag" for a new name.
 * Arrows and Enter pick, Backspace in the empty field removes the last
 * badge, and Esc closes only the menu. */
const TagField = ({
  tags, value, onChange, createdWhen, isDisabled, className, placement = 'below', title = 'Tags', restingHint,
}) => {
  const fieldRef = _react.useRef(null)
  const inputRef = _react.useRef(null)
  const menuId = _react.useId.call(void 0, )
  const [search, setSearch] = _react.useState.call(void 0, '')
  const [isOpen, setOpen] = _react.useState.call(void 0, false)
  const [highlight, setHighlight] = _react.useState.call(void 0, 0)

  const query = search.trim()
  const chosen = new Set(value.TagKeys)
  const newKeys = new Set(value.NewNames.map(nameKey))
  const available = tags.filter(t => !chosen.has(t.TagKey))
  const matches = query
    ? available.filter(t => t.Name.toLowerCase().includes(query.toLowerCase()))
    : [...available].sort((a, b) => (_nullishCoalesce(b.Patients, () => ( 0))) - (_nullishCoalesce(a.Patients, () => ( 0))) || a.Name.localeCompare(b.Name))
  const taken = tags.some(t => nameKey(t.Name) === nameKey(query)) || newKeys.has(nameKey(query))
  const options = [
    ...matches.map(tag => ({ kind: 'tag', tag } )),
    ...(query && !taken ? [{ kind: 'create', name: query } ] : []),
  ]
  const current = Math.min(highlight, options.length - 1)
  const showMenu = isOpen && !isDisabled && options.length > 0
  // The menu is as wide as the field.
  const [menuWidth, setMenuWidth] = _react.useState()
  _react.useLayoutEffect.call(void 0, 
    () => { if (showMenu) setMenuWidth(_optionalChain([fieldRef, 'access', _ => _.current, 'optionalAccess', _2 => _2.offsetWidth])) },
    [showMenu],
  )

  const pick = (option) => {
    if (option.kind === 'tag') {
      onChange({ ...value, TagKeys: [...value.TagKeys, option.tag.TagKey] })
    } else {
      onChange({ ...value, NewNames: [...value.NewNames, option.name] })
    }
    setSearch('')
    setHighlight(0)
    _optionalChain([inputRef, 'access', _3 => _3.current, 'optionalAccess', _4 => _4.focus, 'call', _5 => _5()])
  }

  const removeTag = (key) => onChange({ ...value, TagKeys: value.TagKeys.filter(k => k !== key) })
  const removeNew = (name) => onChange({ ...value, NewNames: value.NewNames.filter(n => n !== name) })

  const onKeyDown = (e) => {
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      e.preventDefault()
      if (!isOpen) {
        setOpen(true)
        setHighlight(0)
        return
      }
      if (options.length === 0) return
      const step = e.key === 'ArrowDown' ? 1 : -1
      setHighlight((current + step + options.length) % options.length)
    } else if (e.key === 'Enter') {
      // Enter picks; it never submits the form.
      e.preventDefault()
      const option = options[current]
      if (showMenu && option) pick(option)
    } else if (e.key === 'Backspace' && search === '') {
      if (value.NewNames.length > 0) {
        removeNew(value.NewNames[value.NewNames.length - 1])
      } else if (value.TagKeys.length > 0) {
        removeTag(value.TagKeys[value.TagKeys.length - 1])
      }
    }
  }

  const byKey = new Map(tags.map(t => [t.TagKey, t]))
  const hasBadges = value.TagKeys.length + value.NewNames.length > 0
  const optionId = (i) => `${menuId}-option-${i}`

  return (
    _react2.default.createElement('div', { className: _classBuilder2.default.call(void 0, 'tag-field', className), __self: this, __source: {fileName: _jsxFileName, lineNumber: 127}}
      ,  title && _react2.default.createElement('span', { className: "blm-input-section--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}},  title , _react2.default.createElement('span', { className: "blm-input-section--title--suffix", __self: this, __source: {fileName: _jsxFileName, lineNumber: 128}}, "(Optional)")) 
      /* A click on the field's padding focuses its input, which has the keyboard.
        * Not a <label>: that would hand the click to the first badge's ×. */
       /* oxlint-disable-next-line jsx-a11y/click-events-have-key-events -- the input inside takes the keyboard */ 
      , _react2.default.createElement('div', {
        ref: fieldRef,
        role: "group",
        'aria-label': "Tags",
        className: _classBuilder2.default.call(void 0, 'blm-text-input tag-field--box', isOpen && 'tag-field--box-focus', isDisabled && 'tag-field--box-disabled'),
        onClick: () => _optionalChain([inputRef, 'access', _6 => _6.current, 'optionalAccess', _7 => _7.focus, 'call', _8 => _8()]), __self: this, __source: {fileName: _jsxFileName, lineNumber: 132}}

        ,  value.TagKeys.map(key => {
          const name = _nullishCoalesce(_optionalChain([byKey, 'access', _9 => _9.get, 'call', _10 => _10(key), 'optionalAccess', _11 => _11.Name]), () => ( 'Tag'))
          return (
            _react2.default.createElement('span', { key: key, className: "blm-name--badge dir-tag dir-tag--removable tag-field--badge"   , title: name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 142}}
              , _react2.default.createElement('span', { className: "tag-field--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 143}},  name )
              , _react2.default.createElement('button', { type: "button", className: "dir-tag--remove", 'aria-label': `Remove tag ${name}`, disabled: isDisabled, onClick: () => removeTag(key), __self: this, __source: {fileName: _jsxFileName, lineNumber: 144}}, "×")
            )
          )
        })
        ,  value.NewNames.map(name => (
          _react2.default.createElement('span', { key: `new:${name}`, className: "blm-name--badge dir-tag dir-tag--removable tag-field--badge"   , title: name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 149}}
            , _react2.default.createElement('span', { className: "tag-field--name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 150}},  name )
            , _react2.default.createElement('span', { className: "tag-field--new", __self: this, __source: {fileName: _jsxFileName, lineNumber: 151}}, "· new" )
            , _react2.default.createElement('button', { type: "button", className: "dir-tag--remove", 'aria-label': `Remove tag ${name}`, disabled: isDisabled, onClick: () => removeNew(name), __self: this, __source: {fileName: _jsxFileName, lineNumber: 152}}, "×")
          )
        ))
        , _react2.default.createElement('input', {
          ref: inputRef,
          className: "tag-field--input",
          'aria-label': "Tags",
          role: "combobox",
          'aria-expanded': showMenu,
          'aria-controls': menuId,
          'aria-autocomplete': "list",
          'aria-activedescendant': showMenu ? optionId(current) : undefined,
          placeholder: hasBadges ? 'Add another' : 'Search or create a tag',
          maxLength: TAG_NAME_MAX,
          disabled: isDisabled,
          value: search,
          onFocus: () => setOpen(true),
          onChange: e => {
            setSearch(e.target.value)
            setHighlight(0)
            setOpen(true)
          },
          onKeyDown: onKeyDown, __self: this, __source: {fileName: _jsxFileName, lineNumber: 155}}
        )
      )
      ,  showMenu && (
        _react2.default.createElement(_Popover2.default, {
          anchorRef: fieldRef,
          placement: placement,
          onClose: () => setOpen(false),
          className: "dir-popover tag-field--menu" ,
          style: { width: menuWidth }, __self: this, __source: {fileName: _jsxFileName, lineNumber: 178}}

          , _react2.default.createElement('div', { id: menuId, role: "listbox", 'aria-label': "Tags", __self: this, __source: {fileName: _jsxFileName, lineNumber: 185}}
            ,  matches.length > 0 && (
              _react2.default.createElement('div', { className: "dir-filters", __self: this, __source: {fileName: _jsxFileName, lineNumber: 187}}
                , _react2.default.createElement('span', { className: "dir-filters--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 188}},  query ? 'Matching tags' : 'Tags' )
                , _react2.default.createElement('div', { className: "dir-filters--options", __self: this, __source: {fileName: _jsxFileName, lineNumber: 189}}
                  ,  matches.map((tag, i) => (
                    _react2.default.createElement('div', {
                      key: tag.TagKey,
                      id: optionId(i),
                      role: "option",
                      'aria-selected': i === current,
                      className: _classBuilder2.default.call(void 0, 'dir-filters--option', i === current && 'tag-field--option-hi'),
                      onMouseEnter: () => setHighlight(i),
                      // Keep the input's focus; the whole row picks the tag.
                      onMouseDown: e => e.preventDefault(),
                      onClick: () => pick({ kind: 'tag', tag }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 191}}

                      , _react2.default.createElement('span', { className: "campaign--table--checkbox", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 202}}, _react2.default.createElement('span', { className: "campaign--table--checkbox-check", __self: this, __source: {fileName: _jsxFileName, lineNumber: 202}} ))
                      , _react2.default.createElement('span', { className: "dir-filters--name", title: tag.Name, __self: this, __source: {fileName: _jsxFileName, lineNumber: 203}}
                        , _react2.default.createElement('span', { className: "blm-name--badge dir-tag" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 204}},  tag.Name )
                      )
                      ,  tag.Patients !== undefined && _react2.default.createElement('span', { className: "dir-filters--count", __self: this, __source: {fileName: _jsxFileName, lineNumber: 206}},  _format.formatCount.call(void 0, tag.Patients) ) 
                    )
                  ))
                )
              )
            )
            ,  query && !taken && (
              _react2.default.createElement('button', {
                type: "button",
                id: optionId(matches.length),
                role: "option",
                'aria-selected': current === matches.length,
                tabIndex: -1,
                className: _classBuilder2.default.call(void 0, 'broadcast-add-dialog--add-new tag-field--create', current === matches.length && 'tag-field--option-hi'),
                onMouseEnter: () => setHighlight(matches.length),
                onMouseDown: e => e.preventDefault(),
                onClick: () => pick({ kind: 'create', name: query }), __self: this, __source: {fileName: _jsxFileName, lineNumber: 213}}

                , _react2.default.createElement('span', { className: "broadcast-add-dialog--add-new-icon", 'aria-hidden': "true", __self: this, __source: {fileName: _jsxFileName, lineNumber: 224}}, "+")
                , _react2.default.createElement('span', { className: "tag-field--create-label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 225}}, "Create tag “"  ,  query , "”")
              )
            )
          )
        )
      )
      ,  value.NewNames.length === 0 && restingHint && _react2.default.createElement('span', { className: "tag-field--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 231}},  restingHint ) 
      ,  value.NewNames.length > 0 && (
        _react2.default.createElement('span', { className: "tag-field--hint", __self: this, __source: {fileName: _jsxFileName, lineNumber: 233}}
          , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 234}},  joinNames(value.NewNames) )
          ,  value.NewNames.length === 1
            ? ` is a new tag: it is created for everyone in your organization ${createdWhen}.`
            : ` are new tags: they are created for everyone in your organization ${createdWhen}.` 
        )
      )
    )
  )
}

exports. default = TagField
